/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { httpService } from 'src/core/services/api/httpService';
import { luisRequestOptionsBuilder } from 'src/core/utils/api/luisRequestOptionsBuilder';
import { urlBuilder } from 'src/core/utils/api/urlBuilder';
import { createService } from 'src/core/utils/createService';

export type FeaturesSettings = { deepStackTraining: boolean };

export const getAccountSettingsService = createService(({ context, getEnvironment }) => {
    const { webApiUrl, isProduction } = getEnvironment();

    const apiOptions = luisRequestOptionsBuilder()
        .useDefaultOptions(context.serviceKey, isProduction)
        .build();

    const getFeaturesSettings = async (): Promise<FeaturesSettings> => {
        const url = urlBuilder()
            .baseUrl(webApiUrl)
            .resource('previewFeatures')
            .build();

        const { data: featuresSettings } = await httpService.get<FeaturesSettings>(url, apiOptions);

        return featuresSettings;
    };

    return { getFeaturesSettings };
});
